export default {
    "name": "GetLicenseInfo",
    "kind": "HoudiniQuery",
    "hash": "f76b1be3df4289ba22b47fe844ac107e8b99badacd5a3f96ba081742824d8e95",

    "raw": `query GetLicenseInfo {
  licenseInfo {
    limits {
      id
      codeName
      displayName
      description
      limit
      count
      belowLimit
    }
    toggles {
      id
      codeName
      displayName
      description
      permissionCode
      active
    }
  }
}
`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "licenseInfo": {
                "type": "GetLicenseResult",
                "keyRaw": "licenseInfo",

                "selection": {
                    "fields": {
                        "limits": {
                            "type": "LicenseLimit",
                            "keyRaw": "limits",

                            "selection": {
                                "fields": {
                                    "id": {
                                        "type": "Int",
                                        "keyRaw": "id",
                                        "visible": true
                                    },

                                    "codeName": {
                                        "type": "String",
                                        "keyRaw": "codeName",
                                        "visible": true
                                    },

                                    "displayName": {
                                        "type": "String",
                                        "keyRaw": "displayName",
                                        "visible": true
                                    },

                                    "description": {
                                        "type": "String",
                                        "keyRaw": "description",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "limit": {
                                        "type": "Int",
                                        "keyRaw": "limit",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "count": {
                                        "type": "Int",
                                        "keyRaw": "count",
                                        "visible": true
                                    },

                                    "belowLimit": {
                                        "type": "Boolean",
                                        "keyRaw": "belowLimit",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "toggles": {
                            "type": "LicenseToggle",
                            "keyRaw": "toggles",

                            "selection": {
                                "fields": {
                                    "id": {
                                        "type": "Int",
                                        "keyRaw": "id",
                                        "visible": true
                                    },

                                    "codeName": {
                                        "type": "String",
                                        "keyRaw": "codeName",
                                        "visible": true
                                    },

                                    "displayName": {
                                        "type": "String",
                                        "keyRaw": "displayName",
                                        "visible": true
                                    },

                                    "description": {
                                        "type": "String",
                                        "keyRaw": "description",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "permissionCode": {
                                        "type": "String",
                                        "keyRaw": "permissionCode",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "active": {
                                        "type": "Boolean",
                                        "keyRaw": "active",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "policy": "NetworkOnly",
    "partial": false
};

"HoudiniHash=9b23434a2a9186c952d2fa2a87459d40178aa556bd35cb0c76afdd3aec8698d1";